export const NETAPP_INTERNAL_STRINGS = {
    "NetAppTest": "NetAppTest",
    "NetAppCourse": "NetAppCourse",
    "NetAppDemo": "NetAppDemo",
    "NetApp": "NetApp"
};

/**
 * The logic here is copied from auth0's code, so that we can get the same internal string for the user as used in SaaS
 * @param {string} userEmail - The email of the user
 * @returns {string} - The internal string for the user
 */
export const getNetAppInternalString = (userEmail) => {
    if (!userEmail) {
        return null;
    }

    const email = userEmail.toLowerCase();
    let internalString = null;

    if (email.startsWith("netapp-test") || email.startsWith("stagoccm") ||
        email.endsWith("@test-netapp.com") || email.endsWith("@netapp-test.com") ||
        email.endsWith("@ntap.com") || email.endsWith("bxpfed.org")
    ) {
        internalString = NETAPP_INTERNAL_STRINGS.NetAppTest;
    }
    if (email.endsWith("@ihcnetappu.com")) {
        internalString = NETAPP_INTERNAL_STRINGS.NetAppCourse;
    }
    if (email.endsWith("@demo.netapp.com")) {
        internalString = NETAPP_INTERNAL_STRINGS.NetAppDemo;
    }
    if (email.startsWith("ptoccm") && email.endsWith("@gmail.com")) {
        internalString = NETAPP_INTERNAL_STRINGS.NetAppTest;
    }
    if (email.endsWith("@netapp.com")) {
        internalString = NETAPP_INTERNAL_STRINGS.NetApp;
    }

    return internalString;
};
